var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("FinanceManage.AddCashFlowItem"),
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        width: "340px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: { "label-width": "120px" },
          model: {
            value: _vm.form,
            callback: function($$v) {
              _vm.form = $$v
            },
            expression: "form"
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "span",
                {
                  staticClass: "blue",
                  attrs: { slot: "label" },
                  slot: "label"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_PleaseSelectVoucherGroupingRule")
                    )
                  )
                ]
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  on: { change: _vm.checkAvailableEntryTypes },
                  model: {
                    value: _vm.form.accountingDocumentRuleUuid,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "accountingDocumentRuleUuid", $$v)
                    },
                    expression: "form.accountingDocumentRuleUuid"
                  }
                },
                _vm._l(_vm.accountingDocumentRules, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { value: item.uuid, label: item.name }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "span",
                {
                  staticClass: "blue",
                  attrs: { slot: "label" },
                  slot: "label"
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PSGROJE")))]
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  model: {
                    value: _vm.form.entryRuleUuid,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "entryRuleUuid", $$v)
                    },
                    expression: "form.entryRuleUuid"
                  }
                },
                _vm._l(_vm.entryRules, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { value: item.uuid, label: item.name }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "span",
                {
                  staticClass: "blue",
                  attrs: { slot: "label" },
                  slot: "label"
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AccountTitleCodeP")))]
              ),
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.form.accountTitle,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "accountTitle", $$v)
                  },
                  expression: "form.accountTitle"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_DebitSideCreditSideP") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  model: {
                    value: _vm.form.codeMappingType,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "codeMappingType", $$v)
                    },
                    expression: "form.codeMappingType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      value: 0,
                      label: this.$t("CargoMsg.Cargo_DebitSide")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 1,
                      label: this.$t("CargoMsg.Cargo_CreditSide")
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }